import { defineAction } from '~/prix'
import propertyMachineryDeleteAction from './propertyMachineryDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const propertyMachineryDeleteDefinition = defineAction({
  ...propertyMachineryDeleteAction,
  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default propertyMachineryDeleteDefinition
